// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cebs-footer {
  background-color: #e2d5cc;
  padding: 0.75rem 1rem;
  text-align: center;
  font-size: 0.875rem;
  border-top: 2px solid #ccc;
  z-index: 1;
  position: relative;
}

.cebs-footer p {
  margin: 0;
  color: #1f2937;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.cebs-highlight {
  color: #111827;
  font-weight: 600;
  font-size: 1rem;
  letter-spacing: 0.3px;
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);
}

/* Floating AI Button */
.chatbot-floating-icon {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background-color: #6c63ff;
  color: white;
  padding: 12px;
  border-radius: 50%;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
}

.chatbot-floating-icon:hover {
  transform: scale(1.05);
}

/* Chat Modal */
.chatbot-modal {
  position: fixed;
  bottom: 90px;
  right: 30px;
  width: 420px;
  height: 600px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  z-index: 99999;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Header */
.chatbot-header {
  background-color: #6c63ff;
  color: white;
  font-weight: bold;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.95rem;
}

.chatbot-close {
  background: none;
  border: none;
  font-size: 20px;
  color: white;
  cursor: pointer;
}

/* Responsive for mobile */
@media (max-width: 600px) {
  .chatbot-modal {
    width: 90%;
    height: 80%;
    right: 5%;
    bottom: 100px;
    border-radius: 10px;
  }

  .chatbot-floating-icon {
    bottom: 20px;
    right: 20px;
    padding: 10px;
  }
}
.main-footer {
  text-align: center;
  font-size: 14px;
  padding: 12px 16px;
  background: #e8dcd2;
  color: #222;
  position: relative;
  z-index: 1;
}

.floating-ai-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: #5a2eed;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 10px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 1000;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}

.floating-ai-button:hover {
  background: #4423b8;
}

.floating-ai-window {
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 400px;
  height: 500px;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  z-index: 1001;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.ai-close-button {
  position: absolute;
  top: 6px;
  right: 10px;
  font-size: 20px;
  color: #555;
  background: none;
  border: none;
  z-index: 10;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/common/Footer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,4DAA4D;AAC9D;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE;IACE,UAAU;IACV,WAAW;IACX,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB","sourcesContent":[".cebs-footer {\n  background-color: #e2d5cc;\n  padding: 0.75rem 1rem;\n  text-align: center;\n  font-size: 0.875rem;\n  border-top: 2px solid #ccc;\n  z-index: 1;\n  position: relative;\n}\n\n.cebs-footer p {\n  margin: 0;\n  color: #1f2937;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.cebs-highlight {\n  color: #111827;\n  font-weight: 600;\n  font-size: 1rem;\n  letter-spacing: 0.3px;\n  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);\n}\n\n/* Floating AI Button */\n.chatbot-floating-icon {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  background-color: #6c63ff;\n  color: white;\n  padding: 12px;\n  border-radius: 50%;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);\n  cursor: pointer;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease-in-out;\n}\n\n.chatbot-floating-icon:hover {\n  transform: scale(1.05);\n}\n\n/* Chat Modal */\n.chatbot-modal {\n  position: fixed;\n  bottom: 90px;\n  right: 30px;\n  width: 420px;\n  height: 600px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);\n  z-index: 99999;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Header */\n.chatbot-header {\n  background-color: #6c63ff;\n  color: white;\n  font-weight: bold;\n  padding: 12px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.95rem;\n}\n\n.chatbot-close {\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: white;\n  cursor: pointer;\n}\n\n/* Responsive for mobile */\n@media (max-width: 600px) {\n  .chatbot-modal {\n    width: 90%;\n    height: 80%;\n    right: 5%;\n    bottom: 100px;\n    border-radius: 10px;\n  }\n\n  .chatbot-floating-icon {\n    bottom: 20px;\n    right: 20px;\n    padding: 10px;\n  }\n}\n.main-footer {\n  text-align: center;\n  font-size: 14px;\n  padding: 12px 16px;\n  background: #e8dcd2;\n  color: #222;\n  position: relative;\n  z-index: 1;\n}\n\n.floating-ai-button {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  background: #5a2eed;\n  color: white;\n  border: none;\n  border-radius: 20px;\n  padding: 10px 16px;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  z-index: 1000;\n  cursor: pointer;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);\n}\n\n.floating-ai-button:hover {\n  background: #4423b8;\n}\n\n.floating-ai-window {\n  position: fixed;\n  bottom: 80px;\n  right: 20px;\n  width: 400px;\n  height: 500px;\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  z-index: 1001;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n}\n\n.ai-close-button {\n  position: absolute;\n  top: 6px;\n  right: 10px;\n  font-size: 20px;\n  color: #555;\n  background: none;\n  border: none;\n  z-index: 10;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
